window._ = require('lodash');

/**
 * Config the jquery-ujs
 */
require('jquery-ujs');
$.rails.csrfParam = function() { return '_token' };

/**
 * Config the dropzone
 */
window.Dropzone = require('dropzone');
window.elementResizeEvent = require('element-resize-event');

require('./libs/bootstrap-datepicker');
require('datepair.js');
require('datepair.js/dist/jquery.datepair.js');
require('select2');
require("select2/dist/css/select2.css");

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */
import VueClipboard from 'vue-clipboards'
import * as VueGoogleMaps from 'vue2-google-maps'
window.Vue = require('vue');
window.Vue.prototype.$eventHub = new Vue();

window.Vue.use(VueClipboard);
window.Vue.use(VueGoogleMaps, {
  load: {
    key:       document.querySelector('meta[name="google-maps-key"]').getAttribute('content'),
    libraries: 'places', // This is required if you use the Autocomplete plugin
  }
});
window.Events = new Vue({});

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


// WEBPACK FOOTER //
// ./resources/assets/js/backend/bootstrap.js